<template>
  <div>
    <Banner theme="orange">
      <template v-slot:title> HTML Blocks </template>
      <template v-slot:description>
        HTML Blocks allow you to create custom HTML-based widgets for display
        the site.
      </template>
      <template v-slot:image>
        <img src="@/assets/banners/widgets/html-blocks.svg" alt="HTML Blocks" />
      </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New HTML Block"
      btn-to="/widgets/html-blocks/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search HTML Blocks"
      :search-text.sync="searchText"
    />

    <div v-if="list">
      <HtmlBlocksDataTable
        v-if="computedList.length"
        :list="computedList"
        @destroy="destroy"
        @duplicate="duplicate"
      />
      <div v-else class="no-entries">No HTML Blocks</div>
    </div>
    <Spinner v-else relative />
  </div>
</template>

<script>
import IndexPage from "../index-page";
import HtmlBlocksDataTable from "@/components/dataview/html-blocks.datatable";

export default {
  name: "WidgetHtmlBlocksPage",
  components: { HtmlBlocksDataTable },
  extends: IndexPage,
  metaInfo() {
    return {
      title: "HTML Blocks",
    };
  },
  methods: {
    async fetchList() {
      const { data } = await this.$api.HtmlBlock.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirmWindow({ title: "Are you sure?" });
      if (!confirmed) return;
      await this.$api.HtmlBlock.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
    async duplicate(item) {
      await this.$api.HtmlBlock.duplicate({ id: item.id });
      this.fetchList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
